<div class="mdc-layout-grid postcontent__outer">
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
      <section class="post__content" [innerHtml]="post?.content | WYSIWYGTagFilter"></section>
      @if (post?.authors?.length) {
      <section class="post__author">
        <ng-container i18n="@@featurePostDetails-postAuthor-from">Von</ng-container>&nbsp;@for (author of post?.authors;
        track identifyAuthor(i, author); let i = $index) {<a
          [routerLink]="
            authorsClickable ? ['/fairs', post?.fair_id, 'exhibitors', post?.exhibitor_id, 'contact', author.id] : []
          "
          >{{ getAuthorName(author) }}</a
        >{{ i + 1 < (post?.authors?.length ?? 0) ? ', ' : '' }}
        }
      </section>
      } @if ((post?.topics | Count) || (post?.product_groups | Count)) {
      <section class="post__tags">
        <planone-expandable-chip-list
          [fairId]="post?.fair_id"
          [chips]="tags"
          [threshold]="8"
          [chipsListClickable]="chipsListClickable"></planone-expandable-chip-list>
      </section>
      }
    </div>
  </div>
</div>
